"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookieByName = exports.tracker = exports.trackerFactoryWithoutDevPrefix = exports.trackerFactoryBase = exports.buildPopulatedTrackdata = void 0;
const env_1 = require("../env");
const dataLayer_1 = require("./dataLayer");
const getGlobalProps_1 = require("./getGlobalProps");
const prefixIfDev_1 = __importDefault(require("./prefixIfDev"));
const sendBeacon_1 = __importDefault(require("./sendBeacon"));
const logger_1 = __importStar(require("./utils/logger"));
const getCookieValue_1 = __importDefault(require("./utils/getCookieValue"));
function buildPopulatedTrackdata(data) {
    // Use both params for backwards compatability
    data.isDebug = data.isDebug !== undefined ? data.isDebug : (0, env_1.isDebug)();
    data.debug = data.isDebug !== undefined ? data.isDebug : (0, env_1.isDebug)();
    data.env = (0, env_1.getEnv)();
    // if we didn't have category, equal it to the event (follow video events on MW pages as a guideline)
    if (!data.category) {
        data.category = data.event;
    }
    // GTM Bug - Always ensure we have a label
    if (!data.label) {
        data.label = data.category;
    }
    // Optionally add global values
    if (data.addGlobalValues) {
        (0, logger_1.logWithQueryParamVerbose)('Adding global variables before', data);
        data = (0, getGlobalProps_1.withAddedGlobalProps)(data);
        (0, logger_1.logWithQueryParamVerbose)('Adding global variables after', data);
    }
    // Add in runtime build variables
    if (data.withRunTimeParams && typeof data.withRunTimeParams === 'function') {
        (0, logger_1.logWithQueryParamVerbose)('Adding runtime variables variables before', data);
        const additionalObjects = data.withRunTimeParams(data) ?? {};
        data = { ...data, ...additionalObjects };
        (0, logger_1.logWithQueryParamVerbose)('Adding runtime variables variables after', data);
    }
    if (data.category && typeof data.categoryPrefixer === 'function') {
        data.category = data.categoryPrefixer(data.category);
    }
    if (data.category && data.shouldPrefixCategoryWithDev && (0, env_1.isDebug)()) {
        data.category = (0, prefixIfDev_1.default)(data.category);
    }
    return data;
}
exports.buildPopulatedTrackdata = buildPopulatedTrackdata;
/**
 *
 * @param values values for this specific event
 * @param trackObjectFunction? optional function that receives the finalized data
 * @param previousMappings internal function used to keep the mappings for singleTrack
 */
function trackWithValues(values, trackObjectFunction, previousMappings) {
    let mappings = previousMappings ?? new Set();
    // root function allows for basic tracking without any defaults
    const track = (options) => {
        try {
            const combinedTrack = buildPopulatedTrackdata({ nonInteractive: true, ...values, ...options });
            const shouldSendToDw = !!combinedTrack.sendToDW;
            const shouldPushToDataLayer = combinedTrack.pushToDataLayer === undefined || combinedTrack.pushToDataLayer;
            const dwPath = combinedTrack.dwPath;
            // Delete config properties
            delete combinedTrack.skipValidation;
            delete combinedTrack.shouldPrefixCategoryWithDev;
            delete combinedTrack.sendToDW;
            delete combinedTrack.dwPath;
            delete combinedTrack.pushToDataLayer;
            delete combinedTrack.addGlobalValues;
            delete combinedTrack.categoryPrefixer;
            delete combinedTrack.withRunTimeParams;
            (0, logger_1.default)(`Event Fired - DW=${shouldSendToDw} DL=${shouldPushToDataLayer}`, combinedTrack);
            (0, logger_1.logWithQueryParamVerbose)('Should send event to DW (true/false): ', shouldSendToDw, combinedTrack, dwPath);
            if (shouldSendToDw) {
                if (!dwPath) {
                    console.error('No DW Path specified in options, cannot send to dw');
                }
                else {
                    (0, logger_1.logWithQueryParamVerbose)('Sending beacon event.');
                    (0, sendBeacon_1.default)(dwPath, combinedTrack);
                }
            }
            if (shouldPushToDataLayer) {
                (0, logger_1.logWithQueryParamVerbose)('Pushing to datalayer.');
                (0, dataLayer_1.track)(combinedTrack);
            }
            // Custom function
            if (typeof trackObjectFunction === 'function') {
                trackObjectFunction(combinedTrack);
            }
            return combinedTrack;
        }
        catch (e) {
            console.error('Track error', e);
        }
    };
    // Common helpers
    track.click = (options) => track({ ...values, ...options, action: 'click', nonInteractive: false });
    track.impression = (options) => track({
        ...values,
        ...options,
        action: 'impression',
        nonInteractive: true,
    });
    track.loaded = (options) => track({ ...values, ...options, action: 'loaded', nonInteractive: true });
    track.singleTrack = (key, options) => {
        if (mappings.has(key)) {
            (0, logger_1.logWithQueryParamVerbose)(`${key} already fired. Not triggering event singleTrack`);
            return null;
        }
        mappings.add(key);
        return track({ ...values, ...options });
    };
    track.resetKeys = () => {
        (0, logger_1.logWithQueryParamVerbose)('Resetting tracking keys keys before clear =', mappings);
        mappings = new Set();
    };
    // Allow infinite expanding with more defaults
    track.extend = (moreDefaults) => trackWithValues({ ...values, ...moreDefaults }, trackObjectFunction, mappings);
    return track;
}
const globalDefaults = {
    addGlobalValues: true,
    pushToDataLayer: true,
    sendToDW: false,
    dwPath: '__track/special/trackingevent', // default to special tracking table
};
function trackerFactoryBase(defaultValues, trackObjectFunction) {
    const defaults = {
        ...globalDefaults,
        ...defaultValues,
    };
    if (!defaults.event && !defaults.category) {
        console.error('[Tracking] Missing event or category field', defaults);
        throw new Error('Missing event or category field');
    }
    // if not category provided but there is an event. Set category to event
    if (!defaults.category) {
        defaults.category = defaults.event;
    }
    // ensure we have an event set
    if (!defaults.event) {
        defaults.event = defaults.category;
    }
    // Prevent data layer pushes and sends to data layer if not on browser
    if (!(0, env_1.isOnBrowser)()) {
        defaults.sendToDW = false;
        defaults.pushToDataLayer = false;
    }
    return trackWithValues(defaults, trackObjectFunction);
}
exports.trackerFactoryBase = trackerFactoryBase;
function trackerFactory(defaultValues, trackObjectFunction) {
    return trackerFactoryBase({ shouldPrefixCategoryWithDev: true, ...defaultValues }, trackObjectFunction);
}
exports.default = trackerFactory;
function trackerFactoryWithoutDevPrefix(defaultValues, trackObjectFunction) {
    return trackerFactoryBase(defaultValues, trackObjectFunction);
}
exports.trackerFactoryWithoutDevPrefix = trackerFactoryWithoutDevPrefix;
// export a simple tracker if needed - prefer using the factory above
exports.tracker = trackerFactoryBase({ category: 'base-tracker' });
exports.getCookieByName = getCookieValue_1.default;
